// angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// ngrx
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

// environment
import { environment } from '../../environments/environment';

// store
import * as fromStore from './';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forRoot(
      {
        ui: fromStore.uiReducer,
        user: fromStore.userReducer,
        trades: fromStore.tradesReducer,
        trade: fromStore.tradeReducer,
        feed: fromStore.feedReducer,
        organizations: fromStore.organizationsReducer,
        organization: fromStore.organizationReducer,
        members: fromStore.membersReducer
      },
      {
        metaReducers: [fromStore.clearState]
      }
    ),
    EffectsModule.forRoot([
      fromStore.UiEffects,
      fromStore.UserEffects,
      fromStore.TradesEffects,
      fromStore.TradeEffects,
      fromStore.FeedEffects,
      fromStore.OrganizationsEffects,
      fromStore.OrganizationEffects,
      fromStore.MembersEffects
    ]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    })
  ]
})
export class AppStoreModule {}
